<template>
  <div class="t-container">
    <div
      class="t-container__body mx-auto"
      :class="[
        VariantClasses[variant],
        { 'px-4 sm:px-6': !mobileFull },
        desktopFull ? 'lg:px-0' : 'lg:px-8 xl:px-9',
      ]"
    >
      <slot class="max-w-screen-sm mx-auto" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import { TContainerVariant } from './constants/types'
import { VariantClasses } from './constants/constants'

defineProps({
  variant: {
    type: String as PropType<TContainerVariant>,
    default: TContainerVariant.normal,
  },
  mobileFull: {
    type: Boolean,
    default: false,
  },
  desktopFull: {
    type: Boolean,
    default: false,
  },
})
</script>
